<template>
  <div class="wl-results" v-if="doc">
    <v-row v-if="mode === 'summary' && filters.length" class="pt-12 px-8">
      <v-col cols="4" v-for="field in filters" :key="field.key">
        Filter by {{ fieldTitle(field).toLowerCase() }}
        <v-select :items="['', ...filterItems(field)]" label="Select from the list"
          v-model.trim="filterValues[field.key]" color="amber"></v-select>
      </v-col>
    </v-row>
    <results-bar :doc="doc" @loadSummary="loadSummary" @loadDoc="loadDoc" :tiles="tiles"
      :users="userList"></results-bar>
    <results-summary v-if="mode === 'summary'" :id="doc.id" :summaryMode="summaryMode" :model="model" :tiles="tiles"
      :localTiles="tiles" :key="model"></results-summary>
    <results-user v-if="mode === 'user'" :uid="currentDoc" :model="model" :localTitles="tiles"
      :resultsModule="resultsModule" :fields="fields"></results-user>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {
  ResultsSummary,
  ResultsUser,
  ResultsBar,
} from "@/components/results/tiles-survey";
import {
  stepFields,
  filterFields,
  fieldTitle,
  filterItems,
  matchesFilter,
} from "@/utils/surveyFields";
const fb = require("@/firebaseConfig.js");

export default {
  name: "ResultTiles",
  props: {
    doc: {
      type: Object,
      default: null,
    },
    model: String,
    resultsModule: String
  },
  data() {
    return {
      summary: true,
      summaryMode: "collated",
      currentDoc: null,
      userList: null,
      items: [],
      mode: "summary",
      content: null,
      // active results filters, keyed by field key
      filterValues: {},
    };
  },
  computed: {
    ...mapState(["exTilesSurvey"]),
    step1() {
      return (
        (this.content &&
          this.content.exercise_tiles_survey &&
          this.content.exercise_tiles_survey.step1) ||
        {}
      );
    },
    // the step 1 form fields declared in the content file
    fields() {
      return stepFields(this.step1);
    },
    // ...of which the ones flagged with "filter": true filter these results
    filters() {
      return filterFields(this.fields);
    },
    filteredDocs() {
      return this.filters.reduce((docs, field) => {
        const selected = this.filterValues[field.key];
        return selected
          ? docs.filter((doc) => matchesFilter(doc, field, selected))
          : docs;
      }, this.items);
    },

    tiles() {
      const arr = []
      this.filteredDocs.forEach((item) => {
        item.selectedTiles.forEach((img) => {
          arr.push(img);
        });
      })
      return arr
    }
  },
  components: {
    ResultsSummary,
    ResultsUser,
    ResultsBar,
  },
  async created() {
    const response = await fetch(`/content/${this.$route.params.id}.json`);
    const data = await response.json();
    this.content = data;
  },
  mounted() {
    this.getExercise();
  },
  watch: {
    // content loads after mount, so build the filter model once we have the fields
    filters(fields) {
      const values = {};
      fields.forEach((field) => {
        values[field.key] = this.filterValues[field.key] || "";
      });
      this.filterValues = values;
    },
  },
  methods: {
    fieldTitle,
    filterItems,
    loadSummary(mode) {
      this.currentDoc = null;
      this.summaryMode = mode;
      this.mode = "summary";
    },
    loadDoc(id) {
      this.currentDoc = id;
      this.mode = "user";
    },
    getExercise() {
      let ref = fb[this.model].where("pid", "==", this.doc.id);
      ref
        .get()
        .then((result) => {
          let items = [];
          let users = [];
          result.docs.forEach((doc) => {
            let post = doc.data();
            users.push(post.id);
            items.push(post)
          });
          if (items) {
            this.items = items;
          }
          if (users) {
            this.userList = users;
          }
        })
        .catch(function () { });
    },
  },
};
</script>
